import { Component, OnInit } from '@angular/core';
import { DefaultPageSize } from '../../../core/dto/defaultPage.size';
import { Pagination } from '../../../core/dto/pagination';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { AppUtils } from '../../../core/config/app.utils';
import { LoadingService } from '../../../core/services/loading.service';
import { CustomerService } from '../../../core/services/customer.service';
import { AgentService } from '../../../core/services/agent.service';
import { SETTINGS } from '../../../core/config/common.settings';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-agent-table',
  templateUrl: './agent-table.component.html',
  styleUrls: ['./agent-table.component.scss']
})
export class AgentTableComponent implements OnInit {
  agentSearch = '';
  pageSize = new DefaultPageSize();
  sortField: any;
  sortOrder: any;
  allCustomers: any;

  sortColumn = {
    compareDate: (a: any, b: any) => {
      return (new Date(a.createdAt) as any) - (new Date(b.createdAt) as any);
    },
    compareName: (a: any, b: any) => a.name.localeCompare(b.name),
  };

  constructor(
    private loading: LoadingService,
    private agentService: AgentService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.getAgentPaged();
  }

  search(): void {
    this.getAgentPaged();
  }

  reset(): void {
    this.agentSearch = "";
    this.getAgentPaged();
  }

  getAgentPaged(): void {
    this.loading.start();
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword: this.agentSearch,
    });

    this.agentService.getAllAgents(payload).then(res => {
      this.allCustomers = res.data;
      this.pageSize.length = res.metadata[0]?.total;
      this.loading.stop();
    });
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;

    const currentSort = params.sort.find(item => item.value !== null);
    this.sortField = (currentSort && currentSort.key) || null;
    this.sortOrder =
      (currentSort && AppUtils.getSortOrder(currentSort.value)) || null;
    this.getAgentPaged();
  }

  protected readonly SETTINGS = SETTINGS;
}
